import { render, staticRenderFns } from "./WaybillCommentAdd.vue?vue&type=template&id=b156192e&"
import script from "./WaybillCommentAdd.vue?vue&type=script&lang=js&"
export * from "./WaybillCommentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QItem,QSelect,QInput,QSeparator,QCardActions,QBtn,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QItem,QSelect,QInput,QSeparator,QCardActions,QBtn,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
